import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import xss from "xss";
export const SafeInnerHTML = memo(({ html, as = "div", ...props }) => {
    const Tag = as;
    return _jsx(Tag, { ...props, dangerouslySetInnerHTML: { __html: xss(html) } });
});
